import {formatDate} from "@/functions/formatting/formatDate";

export const formatProductDates = ({product}) => {
  return {
    ...product,
    dateTimeCreated: formatDate({date: product.dateTimeCreated}),
    dateTimeDelivered: formatDate({date: product.dateTimeDelivered}),
    dateTimeLastFunctionControl: formatDate({
      date: product.dateTimeLastFunctionControl,
    }),
    dateTimeProduced: formatDate({date: product.dateTimeProduced}),
    expectedDeliveryDate: formatDate({date: product.expectedDeliveryDate}),
  };
};
